






































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetTems, DelTem, DelTems, EditTem } from "@/request/common";
@Component({})
export default class Name extends mixins(listMixin) {
  private editData: any = "";
  private ifShowEdit: any = false;
  private ifShowMoshi: any = false;
  private data: any = [];
  private typeOption: any = ["单选", "多选", "判断", "填空"];
  private editCell: any = {
    应用模式: [],
    sex: "",
  };
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private openMoshi(item: any) {
    if (!item["应用模式"]) {
      item["应用模式"] = [];
    }
    this.editCell = JSON.parse(JSON.stringify(item));
    this.ifShowMoshi = true;
  }
  private selectMoshi(val: any) {
    if (this.editCell["应用模式"] && this.editCell["应用模式"].length > 0) {
      const index = this.editCell["应用模式"].indexOf(val);
      if (index == -1) {
        this.editCell["应用模式"].push(val);
      } else {
        this.editCell["应用模式"].splice(index, 1);
      }
    } else {
      this.editCell["应用模式"] = [];
      this.editCell["应用模式"].push(val);
      this.$forceUpdate();
    }
  }
  private moshiSure() {
    this.ifShowMoshi = false;
    console.log(this.editCell);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditTem(this, this.editCell, loading)
      .then(() => {
        loading.close();
        this.$message.warning("修改成功");
        this.getList();
        this.ifShowMoshi = false;
      })
      .catch(() => {
        loading.close();
      });
  }
  private openEdit(item: any) {
    if (item) {
      this.$router.push({
        path: "/main/teacher/resource-shixun-edit",
        query: {
          type: item["类别"],
          id: item.question_template_id,
        },
      });
    } else {
      this.ifShowEdit = true;
    }
  }
  private editSure() {
    this.$router.push({
      path: "/main/teacher/resource-shixun-edit",
      query: {
        type: this.editData,
      },
    });
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            id: item.question_template_id,
          },
        };
        DelTem(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            if (this.data.length === 1 && this.filters.current_page !== 1) {
              this.filters.current_page--;
            }
            this.getList();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private delAll() {
    if (this.selectedMessages.length == 0) {
      this.$message.warning("请选择需要删除的数据");
      return;
    }
    this.$confirm("您确定要删除所选数据么？", "批量删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      let ids: any = [];
      this.selectedMessages.forEach((ele: any) => {
        ids.push(ele.question_template_id);
      });

      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          ids: ids,
        },
      };
      DelTems(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("批量删除成功");
          this.selectedMessages = [];
          if (this.data.length === 1 && this.filters.current_page !== 1) {
            this.filters.current_page--;
          }
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      search: this.filters.search,
      类别: this.filters["分类"],
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    if (this.filters["分类"] == "四诊") {
      params["题目类型"] = this.filters["题目类型"];
    }
    localStorage.setItem("resourceFilter", JSON.stringify(this.filters));
    GetTems(this, params, loading)
      .then((res: any) => {
        loading.close();
        res.data.forEach((element: any) => {
          const inc = this.selectedMessages.findIndex((i: any) => {
            return (
              i["question_template_id"] === element["question_template_id"]
            );
          });
          if (inc !== -1) {
            element["selected"] = true;
          } else {
            element["selected"] = false;
          }
        });
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    if (localStorage.getItem("resourceFilter")) {
      this.filters = JSON.parse(localStorage.getItem("resourceFilter") as any);
    }
    this.getList();
  }
}
